import { useEffect, useState } from "react";
import api from "../../services/api.js";

export default function UpdateDisableListModal({
  isOpen,
  onClose,
  data,
  onSuccess,
}) {
  const [billingStatus, setBillingStatus] = useState("");
  const [note1, setNote1] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /* 🔧 FIX STATE SYNC */
  useEffect(() => {
    if (data) {
      setBillingStatus(data.billing_status || "");
      setNote1(data.note1 || "");
    }
  }, [data]);

  if (!isOpen || !data) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem("token");

      await api.put(
        `/disabled-list/${data.id}`,
        {
          billing_status: billingStatus,
          note1,
        },
        {
          headers: {
            Authorization: token, // atau Bearer jika backend diubah
          },
        }
      );

      onSuccess?.();
      onClose();
    } catch (err) {
      setError(
        err.response?.data?.message || "Gagal memperbarui data disable list"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-xl bg-white dark:bg-gray-800 shadow-xl p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Update Disable List</h2>
          <button onClick={onClose}>✕</button>
        </div>

        {error && (
          <div className="mb-3 rounded bg-red-100 dark:bg-red-900/40 px-3 py-2 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <select
            value={billingStatus}
            onChange={(e) => setBillingStatus(e.target.value)}
            required
            className="w-full p-2 rounded bg-gray-50 dark:bg-gray-700"
          >
            <option value="">-- pilih status --</option>
            <option value="paid">Paid</option>
            <option value="unpaid">Unpaid</option>
            <option value="keep enabled">Keep Enabled</option>
          </select>

          <textarea
            value={note1}
            onChange={(e) => setNote1(e.target.value)}
            rows={3}
            required
            className="w-full p-2 rounded bg-gray-50 dark:bg-gray-700"
          />

          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose}>
              Batal
            </button>
            <button
              type="submit"
              disabled={loading}
              className="bg-indigo-600 text-white px-4 py-2 rounded"
            >
              {loading ? "Menyimpan..." : "Simpan"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
